
<template>
    <v-container fluid>
    <v-card elevation="0" flat tile>
        <v-card-text>
            <v-row justify="center">
                <v-col cols="12" md="12">
                <v-row>
                    <v-col md="11">
                        <p class="text-h5">Files</p>
                    </v-col>
                    <v-col md="1">
                        <v-btn
                        class="button-shadow"
                        color="secondary"
                        @click="isAddFile = true"
                        >
                        Add
                        </v-btn>
                    </v-col>
                </v-row>
                <v-form>
                    <v-data-table
                        :headers="header_files"
                        :items="data_files"
                        :items-per-page="100"
                        class="elevation-0"
                    >
                    <template v-slot:top>
                        <v-dialog v-model="isDeleteFile" width="500">
                            <v-card>
                              <v-card-title> Delete this File? </v-card-title>
                              <v-card-text>
                                {{ delete_file.filename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteFile = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteFile(delete_file)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template>
                    <template v-slot:item.filetype="{ item }">
                        <a v-if="item.filetype=='pdf'" :href="item.fileurl" style="text-decoration: none !important;">
                            <v-icon 
                            size="50"
                            color="primary"
                            >
                              mdi-file-pdf-box
                            </v-icon>
                        </a>    
                    </template>
                    <template v-slot:item.filesize="{ item }">
                        {{ (item.filesize/1000).toFixed(0) + " KB"  }}    
                    </template>
                    <template v-slot:item.createdAt="{ item }">
                        {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-btn
                            icon
                            color="primary"
                            @click="deleteFileDialog(item)"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
                </v-form>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/investjournal/list"
                            replace
                            outlined
                            color="primary"
                        >
                        Done
                        </v-btn>
                        <v-spacer></v-spacer>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
    <div>
        <v-dialog
            v-model="isAddFile"
            persistent
            max-width="600px"
        >
            <v-card>
                <v-card-title>
                    <span class="text-h5">Upload File</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                    <v-row>
                        <v-col cols="12">
                        <v-file-input label="File input" v-model="add_file.file" v-on:change="onChangeFile" accept=".pdf" />
                        </v-col>
                        <v-col cols="12">
                        <v-text-field
                            v-model="add_file.filename"
                            label="File Name"
                            required
                        ></v-text-field>
                        </v-col>
                    </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                    color="blue darken-1"
                    text
                    @click="isAddFile = false; add_file.file=null; add_file.filename=''"
                    >
                    Close
                    </v-btn>
                    <v-btn
                    :disabled="add_file.file==null"
                    color="blue darken-1"
                    text
                    @click="addFile"
                    >
                    Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    </v-container>
</template>

<script>
import {mapActions} from "vuex";
export default {
    props: {
        data: {
            type: Array
        },
        id: String,
        route: String,
    },
    data () {
        return {
            header_files: [
                { text: "Type", value: "filetype" },
                { text: "Name", value: "filename" },
                { text: "Size", value: "filesize" },
                { text: "Created", value: "createdAt" },
                { text: "Actions", value: "actions", sortable: false },
            ],
            data_files: [],
            isAddFile: false,
            isDeleteFile: false,
            isEditFile: false,
            add_file: {},
            delete_file: {},
            edit_file: {},
        }
    },
    methods: {
        ...mapActions('File', [ 'insertFileRouteRequest', 'deleteFileRequest', 'updateFileRequest']),
        async addFile() {
            this.isAddFile = false;
            this.add_file.id = this.id;
            this.add_file.route = this.route;
            let result = await this.insertFileRouteRequest(this.add_file);
            if(result!=null) this.data_files.splice(0,0,result);
            this.add_file = {};
        },
        deleteFileDialog(item) {
            this.isDeleteFile = true;
            this.delete_file = { _id: item._id, desctype: item.desctype };
        },
        async deleteFile(item) {
            this.isDeleteFile = false;
            let result = await this.deleteFileRequest(item);
            let index = this.data_files.findIndex((i) => i._id == result._id);
            this.data_files.splice(index, 1);
        },
        editFileDialog(item) {
            this.isEditFile = true;
            this.edit_file = Object.assign({},item);
        },
        async editFile() {
            this.isEditFile = false;
            let result = await this.updateFileRequest(this.edit_file);
            let index = this.data_files.findIndex((i)=> i._id == result._id);
            this.data_files.splice(index, 1, result);
        },
        onChangeFile(file) {
            if (!file) this.add_file.file = null;
            else this.add_file.file = file;
        },
    },
    created(){
        this.data_files = Object.assign([], this.data);
    }
}
</script>